import React from 'react';
import { ChallengeBlock } from '@/components/ui/content-blocks';
import { Code, Link as LinkIcon, BarChart, Database, Users, TrendingUp } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

const ChallengesBlockExample = () => {
  const { t } = useTranslation();
  
  const challenges = [
    {
      icon: <Code className="h-8 w-8" />,
      title: t('challenges.items.noOrientation.title'),
      description: t('challenges.items.noOrientation.description'),
      solution: t('challenges.items.noOrientation.solution')
    },
    {
      icon: <LinkIcon className="h-8 w-8" />,
      title: t('challenges.items.noConnectivity.title'),
      description: t('challenges.items.noConnectivity.description'),
      solution: t('challenges.items.noConnectivity.solution')
    },
    {
      icon: <BarChart className="h-8 w-8" />,
      title: t('challenges.items.noAutomation.title'),
      description: t('challenges.items.noAutomation.description'),
      solution: t('challenges.items.noAutomation.solution')
    },
    {
      icon: <Database className="h-8 w-8" />,
      title: t('challenges.items.noRealtime.title'),
      description: t('challenges.items.noRealtime.description'),
      solution: t('challenges.items.noRealtime.solution')
    },
    {
      icon: <Users className="h-8 w-8" />,
      title: t('challenges.items.noIT.title'),
      description: t('challenges.items.noIT.description'),
      solution: t('challenges.items.noIT.solution')
    },
    {
      icon: <TrendingUp className="h-8 w-8" />,
      title: t('challenges.items.competition.title'),
      description: t('challenges.items.competition.description'),
      solution: t('challenges.items.competition.solution')
    }
  ];

  return (
    <ChallengeBlock
      id="herausforderungen"
      title={t('challenges.title')}
      subtitle={t('challenges.subtitle')}
      challenges={challenges}
      variant="orange" // Orange-Variante für die Homepage
    />
  );
};

export default ChallengesBlockExample; 